import ko from '@tko/build.knockout';
import $ from 'jquery';
import _ from 'lodash';
import DataRepository from './data-repository';
import DashboardService from '../../modules/assurance/services/dashboard.service';
import FormatterCommon from '../data-formatters/formatter-common';
import LoginService from "../../services/login.service";

function DataRepositoryManager() {
    var self = this;
    self.dataRepository = DataRepository.getInstance();
    self.timers = {};
    self.initializedDatasourceDict = {};
}

DataRepositoryManager.prototype = {
    getSystemDictionaryObservable: function () {
        var self = this;
        return self.dataRepository.dictionaryOfSystemsObservable;
    },

    getDictionaryOfBridgesWithIdsObservable: function () {
        var self = this;
        return self.dataRepository.dictionaryOfBridgesWithIdsObservable;
    },

    getDictionaryOfCallControlsWithIdsObservable: function () {
        var self = this;
        return self.dataRepository.dictionaryOfCallControlsWithIdsObservable;
    },

    getListOfEndpointsObservable: function () {
        var self = this;
        return self.dataRepository.listOfEndpointsObservable;
    },

    getFlexPanelMetaDataObservable: function () {
        var self = this;
        return self.dataRepository.flexQueryMetaData;
    },

    getEndpointModelsObservable: function () {
        var self = this;
        return self.dataRepository.endpointModels;
    },

    getSystemsObservable: function () {
        return this.dataRepository.systemsDictionary;
    },

    getEndpointCallDataObservable: function() {
        var self = this;
        return self.dataRepository.endpointCallData;
    },

    getListOfEndpointsWithIdsObservable: function () {
        var self = this;

        return self.dataRepository.listOfEndpointsWithIdsObservable;
    },

    getPexipLocationsObservable: function () {
        var self = this;
        return self.dataRepository.listOfPexipLocationsObservable;
    },

    hasCallControlDevices: function () {
        var self = this;
        return self.dataRepository.hasCallControlDevices();
    },

    hasBridges: function () {
        var self = this;
        return self.dataRepository.hasBridges();
    },

    hasEndpoints: function () {
        var self = this;
        return self.dataRepository.hasEndpoints();
    },

    addTimer: function(datasourceObj) {
        var self = this;

        if (!datasourceObj.refreshInterval || datasourceObj.refreshInterval <= 0) {
            return;
        }

        if (!self.timers[datasourceObj.refreshInterval]) {
            self.timers[datasourceObj.refreshInterval] = [
                { // timer header
                    timerId: setInterval(function () {self.refreshData(datasourceObj.refreshInterval); }, datasourceObj.refreshInterval * 1000),
                    countsDict: _.set({}, datasourceObj.method, 1)
                },
                {
                    service: datasourceObj.service,
                    method: datasourceObj.method,
                    resType: datasourceObj.resType,
                    params: $.extend(true, {}, datasourceObj.params),
                    observableParams: datasourceObj.observableParams
                }
            ];
            return;
        }

        var newcount = _.get(self.timers, [datasourceObj.refreshInterval, 0, 'countsDict', datasourceObj.method], 0) + 1;

        self.timers[datasourceObj.refreshInterval][0].countsDict[datasourceObj.method] = newcount;

        var foundMethod = false;
        for (var i = 0; i < self.timers[datasourceObj.refreshInterval].length; i++) {
            if (self.timers[datasourceObj.refreshInterval][i].method === datasourceObj.method) {
                $.extend(true, self.timers[datasourceObj.refreshInterval][i].params, datasourceObj.params);
                foundMethod = true;
                break;
            }
        }

        if (!foundMethod) {
            self.timers[datasourceObj.refreshInterval].push({
                service: datasourceObj.service,
                method: datasourceObj.method,
                resType: datasourceObj.resType,
                params: $.extend(true, {}, datasourceObj.params),
                observableParams: datasourceObj.observableParams
            });
        }
    },

    invokeServiceMethod2: function(service, method, resType, params) {
        var self = this;
        return invokeServiceMethod(self.dataRepository, service, method, resType, params);
    },

    refreshData: function(refreshInterval) {
        var self = this;

        //note: first element is a header for each timer with id and counts
        for (var i = 1; i < self.timers[refreshInterval].length; i++) {
            var timerObj = self.timers[refreshInterval][i];
            var service = timerObj.service;
            var method = timerObj.method;
            var params = timerObj.params && timerObj.params.observableParams && timerObj.observableParams ? timerObj.observableParams() : timerObj.params;
            var resType = timerObj.resType;

            if (timerObj.params.observableParams && _.isEmpty(_.result(timerObj, 'observableParams'))) {
                continue;
            }
            invokeServiceMethod(self.dataRepository, service, method, resType, params);
        }
    },

    initializeDatasource: function (datasourceObj) {
        var self = this;

        //if there are observable params, do not invoke method until those params have a value
        if (_.get(datasourceObj, 'params.observableParams') && _.isEmpty(_.result(datasourceObj, 'observableParams'))) {
            return;
        }

        var initsources = Object.keys(self.initializedDatasourceDict);
        var initparams = datasourceObj.initParams || (_.get(datasourceObj, 'params.observableParams') && ko.isObservable(datasourceObj.observableParams) ? datasourceObj.observableParams() : datasourceObj.params);

        if (_.includes(initsources, datasourceObj.method)) {
            var params = self.initializedDatasourceDict[datasourceObj.method];

            if ((datasourceObj.refreshInterval === 0) || !isEqual(params, initparams)) {
                self.initializedDatasourceDict[datasourceObj.method] = $.extend(true, {}, params, initparams);
                invokeServiceMethod(self.dataRepository, datasourceObj.service, datasourceObj.method, datasourceObj.resType, initparams);
            }
        }
        else {
            self.initializedDatasourceDict[datasourceObj.method] = initparams;
            invokeServiceMethod(self.dataRepository, datasourceObj.service, datasourceObj.method, datasourceObj.resType, initparams);
        }
    },

    refreshDataSources: function(dataSources) {
        _.forEach(dataSources, _.bind(function(ds) {
            invokeServiceMethod(this.dataRepository, ds.service, ds.method, ds.resType, {});
        }, this));
    },

    refreshOnParamChange: function (datasourceObj) {
        var self = this;

        if (_.get(datasourceObj, 'params.observableParams') && ko.isObservable(_.get(datasourceObj, 'observableParams'))) {
            datasourceObj.observableParams.subscribe(function () {
                if (!_.isEmpty(datasourceObj.observableParams())) {
                    invokeServiceMethod(self.dataRepository, datasourceObj.service, datasourceObj.method, datasourceObj.resType, datasourceObj.observableParams());
                }
            });
        }
    },

    registerDataSource: function (datasources) {
        var self = this;
        datasources.forEach(function (datasourceObj) {
            self.initializeDatasource(datasourceObj);
            self.addTimer(datasourceObj);
            self.refreshOnParamChange(datasourceObj);
        });
    },

    clearTimers: function() {
        var self = this;

        _.forOwn(self.timers, function(value, timerKey) {
            if (self.timers[timerKey].length > 0) {
                var timerId = self.timers[timerKey][0].timerId;
                clearInterval(timerId);
            }
        });
        self.timers = {};
        delete self.timers;
    },

    dispose: function() {
        var self = this;

        self.dataRepository.dispose();
        self.clearTimers();

        delete self.dataRepository;
        delete self.initializedDatasourceDict;
    }
};

function invokeServiceMethod(dataRepository, service, method, resType, params) {

    if (!dataRepository.beforeInvokingService(method, params)) {
        return Promise.resolve();
    }
    else {
      return routeServiceCall(service, method, resType, params)
        .then(function(result) {
          dataRepository.processWebServiceResult(method, params, result);
          return result;
        })
        .catch(function(error) {
          let msg = error.message;
          dataRepository.invokeServiceFailed(method, params, msg);

          if (msg && _.isFunction(msg.indexOf)) {
            if ((msg.indexOf('token is blank') >= 0) || (msg.indexOf('session has expired') >= 0)) {
                LoginService.navigateToLogin();
            }
          }
        });
    }
}

function routeServiceCall(service, method, resType, params) {
    let promise;
    if (service === "CiscoSparkIntegration.aspx" && method === "AddBotToSpace") {
        promise = DashboardService.addCiscoSparkBotToSpace(params);
    }
    else if (service === "CiscoSparkIntegration.aspx" && method === "RemoveBotFromSpace") {
        promise = DashboardService.removeCiscoSparkBotFromSpace(params);
    }
    else if (service === "CiscoSparkIntegration.aspx" && method === "GetBotSpaceMembership") {
        promise = DashboardService.fetchCiscoSparkBotSpaceMembership(params);
    }
    else if (service === "CiscoSparkIntegration.aspx" && method === "GetBotSpaceMemberships") {
        promise = DashboardService.fetchCiscoSparkBotSpaceMemberships();
    }
    else if (service === "CiscoSparkIntegration.aspx" && method === "GetSpaces") {
        promise = DashboardService.fetchCiscoSparkSpaces(params);
    }
    else if (service === "DatabaseMethods.aspx" && method === "GetFlexQueryMetaData") {
        promise = DashboardService.fetchFlexQueryMetadata();
    }


    else if (service === "DatabaseMethods.aspx" && method === "GetQueryResultDatasetJson") {
        promise = DashboardService.fetchQueryResultDatasetJson(params);
    }
    else if (service === "DatabaseMethods.aspx" && method === "GetSystemsList") {
        promise = DashboardService.fetchSystems(params).then(function(systems) {
            return systems.map(function(system) {
                system['dimsystem.name'] = FormatterCommon.sanitize(system['dimsystem.name']);
                return system;
            });
        });
    }
    else if (service === "DatabaseMethods.aspx" && method === "GetEndpointModels") {
        promise = DashboardService.fetchEndpoints();
    }
    else if (service === "WebexData.aspx" && method === "GetEndpointHistoricalInfo") {
        promise = DashboardService.fetchEndpointHistoricalInfo(params);
    }
    else if (service === "WebMethods.aspx" && method === "UpdateEndpoint") {
        promise = DashboardService.updateEndpoint(params);
    }
    else if (service === "DatabaseMethods.aspx" && method === "GetFiltersForFactKey") {
        promise = DashboardService.fetchFilters(params);
    }
    else if (service === "LinkMethods.aspx" && method === "GetJson") {
        promise = DashboardService.fetchPermaLinkData(params);
    }
    else if (service === "DatabaseMethods.aspx" && method === "GetQueryResultJson") {
        promise = DashboardService.fetchQueryResultJson(params);
    }
    else if (service === "DatabaseMethods.aspx" && method === "GetKPIQueryResultDatasetJson") {
        promise = DashboardService.fetchKPI(params);
    }
    else if (service === "ExportRegistrations.aspx" && method === "AddExportRegistration") {
        promise = DashboardService.addExportRegistration(params);
    }
    else if (service === "ExportRegistrations.aspx" && method === "UpdateExportRegistration") {
        promise = DashboardService.updateExportRegistration(params);
    }
    else if (service === "ExportRegistrations.aspx" && method === "DeleteExportRegistration") {
        promise = DashboardService.deleteExportRegistration(params);
    }
    else if (service === "ExportRegistrations.aspx" && method === "ListExportRegistrations") {
        promise = DashboardService.fetchExportRegistrations();
    }
    else if (service === "WebMethods.aspx" && method === "GetRooms") {
        promise = DashboardService.fetchRooms(params);
    }
    else if (service === "WebMethods.aspx" && method === "UpdateRooms") {
        promise = DashboardService.updateRooms(params);
    }
    else if (service === "WebMethods.aspx" && method === "GetOrgPreferences") {
        promise = DashboardService.fetchOrgPreferences(params);
    }
    else if (service === "WebMethods.aspx" && method === "SaveOrgPreferences") {
        promise = DashboardService.saveOrgPreferences(params);
    }
    else if (service === "WebMethods.aspx" && method === "GetEndpointsJson") {
        promise = DashboardService.fetchEndpointsTemp();
    }
    else if (service === "DatabaseMethods.aspx" && method === "GetSystemsJson") {
        promise = DashboardService.fetchSystemsTemp();
    }

    if (promise) {
      return promise;
    }
    return Promise.reject('routeServiceCall: invalid service or method');
}

function isEqual(params1, params2) {
    if (!params1 && !params2) {
        return true;
    }

    if (!params1 || !params2) {
        return false;
    }

    var keys1 = Object.keys(params1);
    var keys2 = Object.keys(params2);

    if (keys1.length !== keys2.length) {
        return false;
    }

    for (var i = 0; i < keys1.length; i++) {
        if (params1[keys1[i]] !== params2[keys2[i]]) {
            return false;
        }
    }
    return true;
}

export default DataRepositoryManager;
